// Build-time switches for features that are finished but not yet released
// everywhere. Each one is a REACT_APP_ variable, so it is fixed when the
// bundle is built: changing it means building and deploying again.

// The reporting release (release/reporting): every report in one shell at
// /reports/<report>, with its filters, charts, specimen drawer, data
// dictionary and templates, plus the features built for it outside the
// reports page - the species map in the Reports section, collection-site
// groups, a site's county and the week start setting.
//
// REACT_APP_DISABLE_NEW_REPORTS=true builds the app with the reports as they
// were before that release instead (Home/ModalRouter/LegacyReports) and none
// of the features above. Production builds with it until the new reports are
// released there; staging and local builds leave it unset.
export const newReportsEnabled = () =>
  process.env.REACT_APP_DISABLE_NEW_REPORTS !== "true";
